import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "col-md-4" }
const _hoisted_2 = { class: "card card-flush h-md-100" }
const _hoisted_3 = { class: "card-header" }
const _hoisted_4 = { class: "card-title" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "card-body pt-1" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bolder text-gray-600 mb-5" }, " Total users with this role: 5 ")
], -1)
const _hoisted_6 = { class: "card-footer flex-wrap pt-0" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("view role")
const _hoisted_8 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light btn-active-light-primary my-1",
  "data-bs-toggle": "modal",
  "data-bs-target": "#kt_modal_update_role"
}, " edit role ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.name), 1)
        ])
      ]),
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_router_link, {
          as: "a",
          class: "btn btn-light btn-active-primary my-1 me-2",
          to: { name: 'website-role', params: { id: 1 } }
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _hoisted_8
      ])
    ])
  ]))
}